
import XHeader from 'vux/src/components/x-header/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'

import vuescroll from 'vuescroll'
import Error from '@/components/error'
import { mapState, mapActions } from 'vuex'
import { DatetimeStamp } from '@/assets/scripts/utils'
export default {
name: 'record',
props: [],
components: {
XHeader,
Swiper,
SwiperItem,
XButton,
Tab,
TabItem,
Group,
Cell,
CellFormPreview,
'scroller': vuescroll,
Error
},
data () {
return {
isError: false,
ops: {
scrollPanel: {
scrollingX: false
},
bar: {
background: 'rgba(0, 107, 178, 0.3)',
size: '3px',
opacity: 0
}
},
index: sessionStorage.getItem('recordTypeIndex') ? Number(sessionStorage.getItem('recordTypeIndex')) : 0,
recordList: [
{
name: '未办理',
itemList: []
},
{
name: '办理中',
itemList: []
},
{
name: '已办理',
itemList: []
},
{
name: '全部',
itemList: []
}
],
dataList: [],
errorMsg: {
type: 'null',
content: '无办理手续，请查看其他类型'
},
snoDes: '',
currentDate: ''
}
},
computed: {
title () {
return this.$route.meta.title
},
...mapState({
token: state => state.token,
studentId: state => state.userInfo.id,
studentNo: state => state.userInfo.sno,
flowId: state => state.flowInfo.flowId
})
},
created () {
if (this.token && this.flowId) {

this.getRecordList(this.index)
this.getHelperDes()
}
},
mounted () {},
updated () {},
destroyed () {},
watch: {},
methods: {
...mapActions(['currentProcedureInfoAction']),
changeList (index) {

sessionStorage.setItem('recordTypeIndex', index)
this.getRecordList(index)
},
handleScroll (vertical, horizontal, nativeEvent) {
var offsetTop = document.getElementById('tab-outer').offsetTop
if (vertical.scrollTop >= offsetTop) {
this.isFixed = true
} else {
this.isFixed = false
}
},
getRecordList (index) {
this.$vux.loading.show()
let params = {
studentId: this.studentId,
flowId: this.flowId,
'flowBean.isInFlow': 1
}
this.$api.get('/dataManagement/getDataManagementList', params,
r => {
let data = r.data
if (index === 0) {
/* 未办理 */
this.dataList = data.filter(item => {
if (item.status === -1 || item.status === 0 || item.status === 2 || item.status === 5) {
return true
}
})
} else if (index === 1) {
/* 办理中 */
this.dataList = data.filter(item => {
if (item.status === 1 || item.status === 3) {
return true
}
})
} else if (index === 2) {
/* 已办理 */
this.dataList = data.filter(item => {
if (item.status === 4) {
return true
}
})
} else if (index === 3) {
/* 全部 */
this.dataList = data
}
if (this.dataList.length === 0) {
this.isError = true
} else {
this.isError = false
}
this.$vux.loading.hide()
},
err => {
this.$vux.toast.text(err.message, 'middle')
})
},
toMap (name, flowProcedureId, procedureId) {
this.$router.push({
name: 'mapPosition',
params: {
title: name,
flowProcedureId: flowProcedureId,
procedureId: procedureId
}
})
},

getCurrentDate () {
return new Promise((resolve, reject) => {
this.$api.get('/helper/systemDateTime', null, r => {

this.currentDate = r.data
resolve()
},
err => {
this.$vux.toast.text(err.message, 'middle')
})
})
},

getIsOverdue (endDate, procedureBeanId, router, name) {
if (DatetimeStamp(endDate + ' 23:59:59') < DatetimeStamp(this.currentDate)) {
this.getManageState(endDate, procedureBeanId, router, name)
} else {
this.getPreposition(procedureBeanId, router, name)
}
},

getPreposition (procedureBeanId, router, name) {
let params = {
'procedureBean.id': procedureBeanId,
'studentBean.id': this.studentId,
'flowBean.id': this.flowId
}
this.$api.get('/dataManagement', params, r => {
this.$vux.loading.hide()
if (r.data.status === 4 || r.data.status === 1 || r.data.status === 3 || r.data.status === 6) {
this.$router.push({name: 'itemResult', params: { title: name, status: r.data.status }})
} else {
this.$router.push({name: router, params: { title: name, status: r.data.status }})
}
},
err => {
this.$vux.toast.text(err.message, 'middle')
})
},

getManageState (endDate, procedureBeanId, router, name) {
let params = {
'studentId': this.studentId,
'flowId': this.flowId,
'procedureId': procedureBeanId
}
this.$api.get('/dataManagement/getDataManagementList', params, r => {
this.$vux.loading.hide()
if (r.data.length > 0) {
if (r.data[0].status === 4 || r.data[0].status === 1 || r.data[0].status === 3 || r.data[0].status === 6) {
this.$router.push({name: 'itemResult', params: { title: name, status: r.data.status }})
} else {
this.$vux.toast.text('该手续已于' + endDate + '结束办理', 'middle')
}
}
},
err => {
this.$vux.toast.text(err.message, 'middle')
})
},
currentProcedure (subItem, i) {
let itemDate = subItem.flowProcedureBean.startDate
if (i === 0 || subItem.procedureBean.flag.split('')[1] === '1') {

this.getCurrentDate().then(() => {
if (DatetimeStamp(itemDate + ' 00:00:00') <= DatetimeStamp(this.currentDate)) {
let currentProcedureInfo = {
flowProcedureId: subItem.flowProcedureId,
procedureId: subItem.procedureId,
name: subItem.procedureBean.name,
router: subItem.procedureBean.router,
endDate: subItem.flowProcedureBean.endDate,
parentRouter: 'record'
}
this.$store.dispatch('currentProcedureInfoAction', currentProcedureInfo)

if (subItem.flowProcedureBean.flag.split('')[5] === '1' && subItem.procedureId !== 3) {
window.location = subItem.flowProcedureBean.config









} else {
if (subItem.procedureBean.router === 'pay' || subItem.procedureBean.router === 'info') {
this.$router.push({
name: subItem.procedureBean.router,
query: {
flowProcedureId: subItem.flowProcedureId,
procedureId: subItem.procedureId
}
})
} else {
this.getIsOverdue(subItem.flowProcedureBean.endDate, subItem.procedureId, subItem.procedureBean.router, subItem.procedureBean.name)
}
}
} else {
this.$vux.alert.show({
title: subItem.procedureBean.name + '未到办理时间',
content: '请于' + itemDate + '办理',
buttonText: '我知道了'
})
}
})
}
},

getHelperDes () {
let params = {
info: this.studentNo
}
this.$api.get('/helper/des', params,
r => {
this.snoDes = encodeURIComponent(r.data)
},
err => {
console.log('获取HelperDes失败', err)

})
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/record/record.vue